<template>
    <div>
        <div class="common_head">
            <img :src="logoUrl" @click="goHome" alt="">
            <img src="../assets/images/menu.png" @click="handleMenuShow" alt="">
        </div>
        <div class="left_menu" v-show="showMenu" @click="handleMenuClose">
            <div class="left_menu_list" @click.stop :class="{'left_menu_list_open':menuAnimation,'left_menu_list_close':!menuAnimation}">
                <div>
                    <router-link class="router_item router_item_parents" :class="{'opac_10':$route.name=='Home'}" to="/">
                        <span>{{$t('home.menuHome')}}</span>
                        <i class="arrow arrow_transform_45"></i>
                    </router-link>
                    <div class="router_item router_item_parents" :class="{'opac_10':$route.name=='Profile'||$route.name=='Contact'}" v-show="$i18n.locale=='zh'" @click="handlChild(0)">
                        <span>公司介绍</span>
                        <i class="arrow" :class="{'arrow_transform_45':!showChild0,'arrow_transform_90':showChild0}"></i>
                    </div>
                    <div class="router_item_child" v-show="showChild0">
                        <router-link class="router_item" :class="{'c_ff9200':$route.name=='Profile'}" to="/Profile">
                            公司简介
                        </router-link>
                        <router-link class="router_item" :class="{'c_ff9200':$route.name=='Contact'}" to="/Contact">
                            联系我们
                        </router-link>
                    </div>
                    <div class="router_item router_item_parents" :class="{'opac_10':$route.name=='List'&& ($route.params.cat=='1'||$route.params.cat=='2')}" v-show="$i18n.locale=='zh'" @click="handlChild(1)">
                        <span>公司动态</span>
                        <i class="arrow" :class="{'arrow_transform_45':!showChild1,'arrow_transform_90':showChild1}"></i>
                    </div>
                    <div class="router_item_child" v-show="showChild1">
                        <router-link class="router_item" :class="{'c_ff9200':$route.name=='List' && $route.params.cat=='1'}" to="/List/1">
                            公司新闻
                        </router-link>
                        <router-link class="router_item" :class="{'c_ff9200':$route.name=='List' && $route.params.cat=='2'}" to="/List/2">
                            员工天地
                        </router-link>
                    </div>
                    <router-link class="router_item router_item_parents" :class="{'opac_10':$route.name=='Join'}" v-show="$i18n.locale=='zh'" to="/Join">
                        <span>加入我们</span>
                        <i class="arrow arrow_transform_45"></i>
                    </router-link>
                    <div class="router_item router_item_parents" :class="{'opac_10':$route.name=='MaiLeHui' || ($route.name=='List'&&($route.params.cat=='3'||$route.params.cat=='4'))}" v-show="$i18n.locale=='zh'" @click="handlChild(2)">
                        <span>麦乐会</span>
                        <i class="arrow" :class="{'arrow_transform_45':!showChild2,'arrow_transform_90':showChild2}"></i>
                    </div>
                    <div class="router_item_child" v-show="showChild2">
                        <router-link class="router_item" :class="{'c_ff9200':$route.name=='MaiLeHui'}" to="/MaiLeHui">
                            麦乐会介绍
                        </router-link>
                        <router-link class="router_item" :class="{'c_ff9200':$route.name=='List' && $route.params.cat=='3'}" to="/List/3">
                            人人有爱
                        </router-link>
                        <router-link class="router_item" :class="{'c_ff9200':$route.name=='List' && $route.params.cat=='4'}" to="/List/4">
                            公益助学
                        </router-link>
                    </div>
                    <div class="router_item router_item_parents" :class="{'opac_10':$route.name=='MaiXueYuan' ||($route.name=='List'&& $route.params.cat=='5') }" v-show="$i18n.locale=='zh'" @click="handlChild(3)">
                        <span>麦学园</span>
                        <i class="arrow" :class="{'arrow_transform_45':!showChild3,'arrow_transform_90':showChild3}"></i>
                    </div>
                    <div class="router_item_child" v-show="showChild3">
                        <router-link class="router_item" :class="{'c_ff9200':$route.name=='MaiXueYuan'}" to="/MaiXueYuan">
                            麦学园介绍
                        </router-link>
                        <router-link class="router_item" :class="{'c_ff9200':$route.name=='List' && $route.params.cat=='5'}" to="/List/5">
                            学习园地
                        </router-link>
                    </div>
                </div>
                <div class="language_change" @click="handleLanguage">
                    {{$i18n.locale == 'en'?'中文':'EN'}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const logoEn = require('../assets/images/duomai_logo_h5_en.png')
const logoZh = require('../assets/images/duomai_logo_h5.png')
import { store, mutations } from '@/store.js'
export default {
    data() {
        return {
            showMenu: false,
            menuAnimation: true,
            logoUrl: ''
        }
    },
    created() {
        this.$i18n.locale = localStorage.getItem('language') || 'zh'
        this.logoUrl = this.$i18n.locale == 'en' ? logoEn : logoZh
    },
    computed: {
        showChild0() {
            return store.showChild['0']
        },
        showChild1() {
            return store.showChild['1']
        },
        showChild2() {
            return store.showChild['2']
        },
        showChild3() {
            return store.showChild['3']
        },
        locale() {
            return this.$i18n.locale
        }
    },
    watch: {
        '$route'() {
            this.showMenu = false
        },
        'locale'() {
            if (this.$i18n.locale == 'en') {
                this.$router.push({ name: 'Home' })
            }
        }
    },

    methods: {
        goHome(){
            this.$router.push({name:"Home"})
        },
        handleMenuShow() {
            this.menuAnimation = true
            this.showMenu = true
        },
        handleMenuClose() {
            this.menuAnimation = false
            setTimeout(() => {
                this.showMenu = false
            }, 500)
        },
        handlChild: mutations.setShowChild,
        handleLanguage() {
            this.$i18n.locale = this.$i18n.locale == 'zh' ? 'en' : 'zh'
            localStorage.setItem('language', this.$i18n.locale);
            this.logoUrl = this.$i18n.locale == 'en' ? logoEn : logoZh
            this.handlChild()
        }
    }
}
</script>

<style lang="less" scoped>
.opac_10 {
    opacity: 1 !important;
}
.c_ff9200 {
    color: #ff9200 !important;
}
div {
    z-index: 1000;
    & .common_head {
        height: 55px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 20px;
        & img:first-child {
            width: 83.5px;
            height: 28.5px;
            z-index:1000;
        }
        & img:last-child {
            width: 32px;
            height: 32px;
            z-index:1000;
        }
    }
    & .left_menu {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 1000;
        & .left_menu_list {
            width: 200px;
            height: 100%;
            background-color: #fff;
            padding: 16px 0 60px 0;
            position: absolute;
            right: 0px;
            transition: right 1s;
            & > div:first-child {
                width: 100%;
                height: 100%;
                overflow-y: auto;
                & .router_item_parents {
                    opacity: 0.8;
                }
                & .router_item {
                    width: 200px;
                    height: 44px;
                    line-height: 44px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding: 0 19px 0 16px;
                    & span {
                        font-size: 16px;
                        color: #1f1f1f;
                    }
                    & .arrow {
                        display: inline-block;
                        border-top: 2px solid;
                        border-right: 2px solid;
                        width: 9.35px;
                        height: 9.35px;
                        border-color: rgba(0, 0, 0, 0.25);
                        transition: transform 200ms;
                    }
                    & .arrow_transform_45 {
                        transform: rotate(45deg);
                    }
                    & .arrow_transform_90 {
                        transform: rotate(135deg);
                    }
                }
                & .router_item_child {
                    background: #f7f7f7;
                    transition: height 3s;
                    & a {
                        display: block;
                        width: 200px;
                        height: 44px;
                        line-height: 44px;
                        font-size: 16px;
                        color: #666666;
                        padding-left: 23px;
                    }
                    & a:active {
                        color: #ff9200;
                    }
                }
            }
        }
        & .language_change {
            width: 60px;
            height: 28px;
            text-align: center;
            line-height: 28px;
            box-sizing: border-box;
            border: 1px solid #666;
            border-radius: 14px;
            font-size: 14px;
            color: #2a2a2a;
            position: absolute;
            bottom: 16px;
            right: 124px;
        }
        & .left_menu_list_open {
            animation: menuOpen 500ms;
        }
        & .left_menu_list_close {
            animation: menuClose 500ms;
        }
    }
}

@keyframes menuOpen {
    0% {
        right: -200px;
    }
    100% {
        right: 0px;
    }
}

@keyframes menuClose {
    0% {
        right: 0px;
    }
    100% {
        right: -200px;
    }
}
</style>